import { InfoCookiesAction } from "./actions";

export interface IInfoCookies {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Website.CookiesNotificationViewModel;
};

const initialInfoCookies: IInfoCookies = {
  isFetching: false,
  isFetchFailed: false,
  content: null,
};

function infoCookies(
  state: IInfoCookies = initialInfoCookies, 
  action: InfoCookiesAction,
  ): IInfoCookies {

  switch (action.type) {
    case 'SET_IS_FETCHING_COOKIES_CONTENT':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_COOKIES_CONTENT_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'SET_COOKIES_CONTENT':
      return {
        ...state,
        content: action.content,
        isFetching: false,
        isFetchFailed: false,
      };

    default:
      return state;
  }
}

export default infoCookies;


// WEBPACK FOOTER //
// ./src/components/CookiesPopup/Redux/reducer.tsx